$(function(){
  console.log("modal login loaded");
	$('#login').on('click', function(event){
    console.log("ciao da login");
    var csrfParam = $('meta[name="csrf-param"]').attr('content');
    var csrfToken = $('meta[name="csrf-token"]').attr('content');
    var csrfField = '';
    if (csrfParam && csrfToken) {
      csrfField = '<input type="hidden" name="' + csrfParam + '" value="' + csrfToken + '" /> ';
    }
		bootbox.dialog({
            className: 'login_modal',
			title: "Effettua il Login.",
			message:'<div class="row">  ' +
                      '<div class="col-md-12"> ' +
            '<form id="login_form" class="form-horizontal" action="/user_sessions" method="post"> ' +
              csrfField +
                          '<div class="form-group"> ' +
                            '<label class="col-md-3 control-label" for="name">Email</label> ' +
                            '<div class="col-md-9"> ' +
                              '<input id="email" name="user_session[email]" type="text" placeholder="email@login.it" class="form-control"> ' +
                            '</div> ' +
                          '</div> ' +

                          '<div class="form-group"> ' +
                            '<label class="col-md-3 control-label" for="name">Password</label> ' +
                            '<div class="col-md-9"> ' +
                              '<input id="password" name="user_session[password]" type="password" placeholder="*********" class="form-control"> ' +
                            '</div> ' +
                          '</div> ' +
                        '</form>' + 
                      '</div>' + 
                    '</div>',
            buttons: {
            	success: {
                  label: "Accedi",
                  className: "btn-success",
                  callback: function () {
				            $("#login_form").trigger("submit");
                  }
                }
			}
		});
	});
});
